import { createVNode as _createVNode } from "vue";
import { defineComponent } from 'vue';
import Abstract from '../abstract';
import { VcCheckboxGroup } from '../vc-checkbox';
export default defineComponent({
  name: 'ColorCheckboxGroup',
  extends: Abstract,
  mixins: [VcCheckboxGroup],
  data: function data() {
    return {
      className: 'color-checkbox-group'
    };
  },
  render: function render() {
    var items = this.$slots.default && this.$slots.default();
    var itemList = this.filterItem(items, 'ColorCheckbox');
    return _createVNode("div", {
      "class": this.prefixCls
    }, [itemList]);
  }
});